import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { GET_AD_UNIT } from 'features/inventory/api/queries/adUnit'
import { useFeatureFlag } from 'features/user/hooks/useFeatureFlag'
import { useAbility } from 'providers/casl'
import { DEFAULT_POOLING_INTERVAL } from 'providers/graphql/constants'
import { adUnitForFormFromDTO } from './api/mappers/adUnitForForm'
import { AdUnitForForm, UseGetAdUnit, UseGetAdUnitProps } from './types'

export const useGetAdUnit = ({ id }: UseGetAdUnitProps): UseGetAdUnit => {
  const [adUnit, setAdUnit] = useState<AdUnitForForm>()
  const ability = useAbility()

  const { isFeatureEnabled: withControllingRefreshParamsOnAdUnitLevel } = useFeatureFlag(
    'yp2827ControlingRefreshParamsOnAdUnitLevel',
  )

  const { loading } = useQuery(
    GET_AD_UNIT({ ability, withControllingRefreshParamsOnAdUnitLevel }),
    {
      onCompleted: ({ node: adUnit }) => {
        if (adUnit) {
          setAdUnit(adUnitForFormFromDTO(adUnit))
        }
      },
      pollInterval: DEFAULT_POOLING_INTERVAL,
      skip: !id,
      variables: { id: id! },
    },
  )

  return { adUnit, loading }
}
